<!--
 * @Description: 大图预览
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-06 15:18:49
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text class="black--text" style="padding-top: 20px;" >
          <v-img
            :src="image"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.1)"
            @click="Image()"
          >
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      image: ''
    };
  },
  methods: {
    info(state, image) {
      this.dialog = state;
      this.image = image;
    },
    Image(){
      if( this.image == '' ){ return }
      window.open(this.image,'newwindow', `height=600, width=800, top=${ document.body.clientHeight/2 - 200 }, left=${ document.body.clientWidth/2 - 400 }, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`);
    }
  }
};
</script>